import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "form__submit btn btn--fullscreen" }

import {computed, ref} from "vue"
import {required, mustMatchEmailFormat} from "@/validation/rules"

import Card from "@/components/layout/Card.vue"
import FormInput from "@/components/forms/FormInput.vue"
import FormTooltip from "@/components/forms/FormTooltip.vue";

import {useI18n} from "vue3-i18n"
import {useUserService} from "@/inversify.config"
import {useMemberStore} from "@/stores/memberStore"

import {SucceededOrNotResponse} from "@/types/responses/succeededOrNotResponse"
import {IChangeEmailRequest} from "@/types/requests/changeEmailRequest"
import {Status} from "@/validation";
import { notifyError, notifySuccess } from "@/notify";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeEmail',
  setup(__props) {

const {t} = useI18n()
const memberStore = useMemberStore()
const userService = useUserService()

const newEmail = ref<string>("")
const newEmailInput = ref<typeof FormInput>()

const currentEmail = computed(() => memberStore.getMember.email)

const changeEmailResponse = ref<SucceededOrNotResponse>()

const inputValidationStatuses:any = {};
async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

async function showErrorMessages() {
  newEmailInput.value?.validateInput(newEmail.value);
}

async function handleSubmit() {
  showErrorMessages();

  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  const request = {
    newEmail: newEmail.value
  } as IChangeEmailRequest
  changeEmailResponse.value = await userService.changeEmail(request)

  changeEmailResponse.value.succeeded
    ? notifySuccess(t('email.form.successMessage'))
    : notifyError(t('email.form.failedMessage'));

  let logoutButton = document.getElementById('js-logout-btn') as HTMLElement
  logoutButton.click()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    title: _unref(t)('email.form.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        novalidate: "",
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [
        _createVNode(FormInput, {
          ref_key: "newEmailInput",
          ref: newEmailInput,
          name: "email",
          type: "email",
          modelValue: newEmail.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newEmail).value = $event)),
          label: _unref(t)('email.form.label'),
          placeholder: currentEmail.value,
          rules: [_unref(required), _unref(mustMatchEmailFormat)],
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label", "placeholder", "rules"]),
        _createVNode(FormTooltip, null, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: _unref(t)('email.form.warning')
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createElementVNode("button", _hoisted_3, _toDisplayString(_unref(t)('global.save')), 1)
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})